
import OLCesium from "olcs/OLCesium";
import * as Cesium from 'cesium';
import {callService} from "@/helpers/ol/ol-http-helper";
import {init3DTileLayers} from "@/modules/cesium/cesium-service";
import {loadCesiumInfo} from "@/modules/cesium/cesium-info";
import {transform} from "ol/proj";
import {viewFit} from "@/helpers/ol/ol-view";
import {Point} from "ol/geom";
import {setMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {loadRightMouseButton} from "@/helpers/right-mouse-button-helper";
import {isVisibleBySelector} from "@/helpers/element-helper";
import {displayFeatureInfo, displayFeatureInfo3D} from "@/modules/ol/service/ol-service-wms";
import {isCesiumMeasureEnabled} from "@/modules/cesium/cesium-measure";
import {Cartesian2, Cartesian3, Cesium3DTileset, ShadowMode} from "cesium";
import {getDefaultSession} from "@/helpers/user-session-helper";
import {addCesiumMarker} from "@/modules/cesium/cesium-marker";
import {hide2DSettings, show2DSettings} from "@/helpers/cesium/cesium-helper";
import {computeAngleToZenith, pickBottomPoint, rotateAroundAxis} from "olcs/core";
import {getLatLonProjectionName, getViewProjectionName} from "@/helpers/ol/ol-projection-helper";

window.Cesium = Cesium;

let scene = undefined
export function getCesium() {
    return window.olCesium
}

export function getCesiumScene() {
    return scene;
}

let target
document.addEventListener('mousemove', (event) => {
    target = event.target.localName
});

export function initCesium(withPitch = false, userSession = undefined) {

    hide2DSettings()

    if (window.olCesium === undefined) {

        if(window.settings.CesiumIonDefaultAccessToken) {
            Cesium.Ion.defaultAccessToken = window.settings.CesiumIonDefaultAccessToken;
        }

        if(window.settings.GoogleMapsApiKey) {
            Cesium.GoogleMaps.defaultApiKey = window.settings.GoogleMapsApiKey
        }
        // window.CESIUM_BASE_URL = 'http://cesium-dev.s3-website-us-east-1.amazonaws.com/cesium/worker-inline/Build';
        // window.CESIUM_BASE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/cesium/1.110.0/';
        window.CESIUM_BASE_URL = `node_modules/cesium/Build/Cesium/`;
        // window.CESIUM_BASE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/cesium/1.108.0/';
        // window.CESIUM_BASE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/cesium/1.108.0/';
        // window.CESIUM_BASE_URL = 'https://helpdesk.kaartviewer.nl/kvhelp/cesium/Build/Cesium/';

        const timeElt = document.getElementById('time');
        const timeDate = document.getElementById('date');
        window.olCesium = new OLCesium(
            {
                // target: 'map',
                map: window.map,
                sceneOptions: {
                    terrainExaggeration: 1.00
                },
                time() {
                    const time = timeElt.value;
                    const date = timeDate.value;
                    if (time) {
                        const d = new Date();
                        d.setHours(time);
                        d.setFullYear(date.split('-')[2], date.split('-')[1] - 1, date.split('-')[0]);

                        return Cesium.JulianDate.fromDate(d);
                    }
                    return Cesium.JulianDate.now();
                }
            }
        )

        scene = window.olCesium.getCesiumScene();

        Cesium.CesiumTerrainProvider.fromUrl(
            window.settings.CesiumTerrainProviderUrL
        ).then((terrainProvider) => {
            scene.terrainProvider = terrainProvider;
        })

        const globe = scene.globe;

        scene.highDynamicRange = false
        scene.screenSpaceCameraController.enableLook = false
        scene.screenSpaceCameraController.enableCollisionDetection = true

        scene.screenSpaceCameraController.inertiaZoom = 0.8
        scene.screenSpaceCameraController.inertiaTranslate = 0.8

        // Schakel shadow maps in
        scene.shadowMap.enabled = false;
        // Set shadow map size (trade-off between quality and performance)
        scene.shadowMap.size = 2048; // Default is 2048, use 1024 or 512 for better performance

        // Optimize shadow distance
        scene.shadowMap.maximumDistance = 5000.0; // Reduce from default 20000 for better performance

        // Shadow map filtering (affects quality vs performance)
        scene.shadowMap.softShadows = false; // Disable for better performance
        scene.shadowMap.darkness = 0.3; // Adjust darkness without affecting performance

        scene.requestRenderMode = true;
        scene.maximumRenderTimeChange = Infinity;

        globe.maximumScreenSpaceError = 1;
        globe.depthTestAgainstTerrain = true;
        globe.undergroundColor = Cesium.Color.ORANGE;
        globe.undergroundColorAlphaByDistance = new Cesium.NearFarScalar(0.0, 0.5, 0.0, 0.5);
        globe.enableLighting = false;
        globe.shadows = ShadowMode.ENABLED;

        init3DTileLayers()

        const selected = {
            feature: undefined,
            originalColor: new Cesium.Color(),
        };

        const highlighted = {
            feature: undefined,
            originalColor: new Cesium.Color(),
        };

        const handlerHighLight = new Cesium.ScreenSpaceEventHandler(window.olCesium.canvas);

        var handler_right = new Cesium.ScreenSpaceEventHandler(window.olCesium.canvas);
        handler_right.setInputAction(function (movement, type, modifier) {

            if (target !== 'canvas') {
                return
            }

            if (!isCesiumEnabled()) {
                return
            }

            if (isCesiumMeasureEnabled()) {
                return
            }

            const feature = scene.pick(movement.position);

            if (!Cesium.defined(feature) && isVisibleBySelector('bookmark-right-mouse-button')) {
                const mousePosition = new Cesium.Cartesian2(event.clientX, event.clientY);
                const selectedLocation = convertScreenPixelToLocation(mousePosition);

                if (selectedLocation) {
                    const coordinate = transform([selectedLocation.lng, selectedLocation.lat], getLatLonProjectionName(), getViewProjectionName())
                    setMapClickMarker(coordinate)
                    loadRightMouseButton(coordinate, false)
                }
                return;
            }

            if (!Cesium.defined(feature) || !feature.tileset) {
                const position =  scene.pickPosition(movement.position);
                if (Cesium.defined(position)) {
                    let cartographic = Cesium.Cartographic.fromCartesian(position);
                    let lat = Cesium.Math.toDegrees(cartographic.latitude);
                    let lon = Cesium.Math.toDegrees(cartographic.longitude);

                    window.height3D = cartographic.height.toFixed(2)
                    //// console.log(cartographic.height)

                    addCesiumMarker(position)
                    displayFeatureInfo3D(lat, lon);
                }
                return
            }

            feature.color = Cesium.Color.RED;
            selected.feature = feature

            const layer = window.layersLoaded.find(layer => layer.Url === feature.tileset._url)
            const linkedForm = layer.Forms[0]

            if (linkedForm && linkedForm.LinkedLayer) {
                const LinkedLayer = linkedForm.LinkedLayer
                const keyColumn = LinkedLayer.keyColumnValue
                const keyColumnValue = LinkedLayer.keyColumnValue

                let featureID
                if(feature.getProperty(keyColumn)) {
                    featureID = feature.getProperty(keyColumn).replace(/[^0-9]/g, '');
                }

                if(feature.getProperty(keyColumnValue)) {
                    featureID = feature.getProperty(keyColumn).replace(/[^0-9]/g, '');
                }

                if(featureID) {
                    callService(undefined, featureID, 'wfs', layer.DomainID, linkedForm.PresentationLinkedID)
                }
            } else {
                loadCesiumInfo(feature)
            }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

        handlerHighLight.setInputAction(function onMouseMove(
                movement
            ) {

                // if (Cesium.defined(highlighted.feature)) {
                if (highlighted.feature) {
                    highlighted.feature.color = highlighted.originalColor;
                    highlighted.feature = undefined;
                }
                // }

                if (target !== 'canvas') {
                    return
                }

                if (!isCesiumEnabled()) {
                    return
                }

                if (isCesiumMeasureEnabled()) {
                    return;
                }

                const pickedFeature = scene.pick(movement.endPosition);

                // const ray = scene.camera.getPickRay(movement.endPosition);
                // const pickedFeature = scene.globe.pick(ray, scene);


                if (!Cesium.defined(pickedFeature)) {
                    return;
                }

                if (!selected.feature || !pickedFeature.feature || pickedFeature.feature.getProperty('id') !== selected.feature.getProperty('id')) {
                    highlighted.feature = pickedFeature;
                    Cesium.Color.clone(
                        pickedFeature.color,
                        highlighted.originalColor
                    );
                    pickedFeature.color = Cesium.Color.AQUA;
                }
            },
            Cesium.ScreenSpaceEventType.MOUSE_MOVE);

        olCesium.enableAutoRenderLoop();

        //

        document.addEventListener('keydown', function(e) {
            setKey(e);
        }, false);

        function setKey(event) {
            const camera = scene.camera;
            var horizontalDegrees = 10.0;
            var verticalDegrees = 10.0;
            var viewRect = camera.computeViewRectangle();
            if (Cesium.defined(viewRect)) {
                horizontalDegrees *= Cesium.Math.toDegrees(viewRect.east - viewRect.west) / 360.0;
                verticalDegrees *= Cesium.Math.toDegrees(viewRect.north - viewRect.south) / 180.0;
            }

            switch (event.keyCode) {
                case 37: // left arrow
                    camera.rotateLeft(Cesium.Math.toRadians(horizontalDegrees));
                    break;
                case 38: // up arrow
                    camera.rotateDown(Cesium.Math.toRadians(verticalDegrees));
                    break;
                case 39: // right arrow
                    camera.rotateRight(Cesium.Math.toRadians(horizontalDegrees));
                    break;
                case 40: // down arrow
                    camera.rotateUp(Cesium.Math.toRadians(verticalDegrees));
                    break;
                case 61: // Zoom in
                    camera.zoomIn(100)
                    break;
                case 173: // Zoom out
                    camera.zoomOut(100)
                    break;
            }
        }
    }

    if(!window.olCesium.getEnabled()) {
        window.olCesium.setEnabled(true);

        // const camera = scene.camera;
        // const angle = 0.05
        // const pivot = pickBottomPoint(scene);
        // if (!pivot) {
        //     // Could not find the bottom point
        //     return;
        // }
        //
        // const options = {};
        // const transform = Cesium.Matrix4.fromTranslation(pivot);
        // const axis = camera.right;
        // // const angle = computeAngleToZenith(scene, pivot);
        //
        // setTimeout(() => {
        //
        //     rotateAroundAxis(camera, -angle, axis, transform, options);
        // }, 10000)

        // window.olCesium.getCesiumScene().camera.setView({
        //     orientation: {
        //         heading : 0.0,
        //         pitch : Cesium.Math.toRadians(-70),
        //         roll : 0.0
        //     }
        // });
        // window.olCesium.getCesiumScene().camera.moveBackward(300)
    }

    if(withPitch || userSession) {

        let x =  Number(window.urlParamsObject.x)
        let y = Number(window.urlParamsObject.y)
        let zoom = Number(window.urlParamsObject.zoom)

        let heading =  Number(window.urlParamsObject.heading)
        let pitch =  Number(window.urlParamsObject.pitch)
        let roll = Number(window.urlParamsObject.roll)
        let duration = 1

        if(!userSession) {
            userSession = getDefaultSession()
        }

        if(userSession) {
            x =  Number(userSession.X)
            y = Number(userSession.Y)
            zoom = Number(userSession.Zoom)

            heading =  Number(userSession.Heading)
            pitch =  Number(userSession.Pitch)
            roll = Number(userSession.Roll)
            duration = 0
        }

        const camera = new Cesium.Camera(scene);

        camera.flyTo({
            destination : Cesium.Cartesian3.fromElements(x, y, zoom),
            orientation : {
                heading : heading,
                pitch : pitch,
                roll : roll
            },
            pitchAdjustHeight: 100,
            maximumHeight: 200
        });
    }


}

export function disableCesium() {
    show2DSettings()
    if(window.olCesium !== undefined) {
        window.olCesium.setEnabled(false);
    }
}

export function isCesiumEnabled() {
    if(!window.olCesium) {
        return false
    }
    return window.olCesium.getEnabled()
}

export function convertScreenPixelToLocation(mousePosition) {

    const ellipsoid = getCesiumScene().globe.ellipsoid;

    const cartesian = getCesiumScene().camera.pickEllipsoid(mousePosition, ellipsoid);

    if (cartesian) {

        const cartographic = ellipsoid.cartesianToCartographic(cartesian);

        const longitudeString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(15);

        const latitudeString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(15);

        return {lat: Number(latitudeString), lng: Number(longitudeString)};
    } else {
        return null;
    }
}

export function toggleDepthTestAgainstTerrain(allow) {
    window.olCesium.getCesiumScene().globe.depthTestAgainstTerrain = allow
    reloadCesium()
}

export function toggleShadowMap(allow) {
    window.olCesium.getCesiumScene().shadowMap.enabled = allow
    window.olCesium.getCesiumScene().globe.enableLighting = allow
    reloadCesium()
}

export function toggleAllowCameraUnderTerrain(allow) {
    window.olCesium.getCesiumScene().screenSpaceCameraController.enableCollisionDetection = allow
}

export function reloadCesium() {
    if(isCesiumEnabled()) {
        setTimeout(() => {
            window.olCesium.getCesiumScene().camera.moveBackward(0.0001)
        })
    }
}
